import OutlineEditPopup from './OutlineEditPopup';

export default OutlineEditPopup;